export default __webpack_public_path__ + "static/media/Realcase-socialMedia-mobile.d0b3ed1f.jpg";